import { atom } from "recoil";

import { NotDraggingDataConst } from "../../constants";
import { IStationPossiblePassengers, TDragCourseData } from "../../models";

export const courseDraggingStationsTempIdsAtom = atom<number[] | undefined>({
  key: "courseDraggingStationsTempIdsAtom",
  default: undefined,
});

export const courseDraggingDataAtom = atom<TDragCourseData>({
  key: "courseDraggingDataAtom",
  default: NotDraggingDataConst,
});

export const courseHasUnsavedStationChangeAtom = atom<boolean>({
  key: "courseHasUnsavedStationChangeAtom",
  default: false,
});

export const courseEditHasMetadataChangedAtom = atom<boolean>({
  key: "courseEditHasMetadataChangedAtom",
  default: false,
});

export const coursePotentialPassengersAtom = atom<
  IStationPossiblePassengers[] | undefined
>({
  key: "coursePotentialPassengersAtom",
  default: undefined,
});
